// extracted by mini-css-extract-plugin
module.exports = {"container":"src-container-CampaignProducts-CampaignProductsContainer-index-module__container--s8NX7"};